import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  NextLink,
  Operation,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import Cookies from 'universal-cookie';

import appConfig from '../config/app.config';
import { offsetLimitPagination } from '@apollo/client/utilities';

const cookies = new Cookies();

const errorLink: ApolloLink = onError((error: any) => {
  if (error?.networkError?.response?.status === 401) {
    cookies.remove('access_token');
    window.location.href = '/login';
  }
});

const authMiddleware: ApolloLink = new ApolloLink((operation: Operation, forward: NextLink) => {
  const accessToken = cookies.get('access_token');
  if (accessToken) {
    // add the authorization to the headers
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        authorization: 'Bearer ' + accessToken,
      },
    }));
  }

  return forward(operation);
});

const httpLink: HttpLink = new HttpLink({ uri: `${appConfig.apiUrl}/graphql` });

export default new ApolloClient({
  ssrMode: false,
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          getNotifications: offsetLimitPagination(),
        },
      },
    },
  }),
  link: ApolloLink.from([errorLink, authMiddleware, httpLink]),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    },
    mutate: {
      errorPolicy: 'none',
    },
  },
});
